module.exports = __webpack_public_path__ + "img/horizontal_bar_selector.d16bfc85.svg";